// extracted by css-extract-rspack-plugin
export default {"container":"A4yWoqlnCGEsskzm","label-wrapper":"KCjgb0MfhEcTaRVR","labelWrapper":"KCjgb0MfhEcTaRVR","label":"n_9CLSGpHEloWqc6"};